import Hero from "../Hero";
import PopularProducts from "../PopularProducts";
import AboutUs from "../AboutUs";

import WhyChooseUs from "../WhyChooseUs";
import AuthorizedBrands from "../AuthorizedBrands";
// import Contact from "./components/Pages/Contact";

function HomePage() {
  return (
    <>
      <Hero />
    
      < PopularProducts />
      < WhyChooseUs />
      < AboutUs />
      < AuthorizedBrands />
   

    </>
  );
}

export default HomePage;
